import { makeStyles } from '@mui/styles';
import { HomeRootBackground } from '../../assets/assetSelector';

const homeStyles = makeStyles((theme) => {
  return {
    root: {
      // height: '100vh',
      // display: 'flex',
      // alignItems: 'center',
      // justifyContent: 'center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      // backgroundAttachment: 'fixed',
    },
    rootLoggedIn: {
      backgroundImage: `url(${HomeRootBackground(true)})`,
    },
    rootLoggedOut: {
      backgroundImage: `url(${HomeRootBackground(false)})`,
    },
    sendMoneyCard: {
      width: '95%',
      top: '-29vh',
      margin: '0 auto',
      [theme.breakpoints.up('sm')]: {
        width: '350px',
      },
      background: theme.palette.specifics.sendMoneyCard,
      position: 'relative',
      color: theme.palette.primary.dark,
    },
    sendMoneyDiv: {
      height: `calc(65vh - ${theme.config.isTopNavbarFixed ? '0px' : '96px'})`,
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    marketingDiv: {
      minHeight: '35vh',
      width: '100%',
      backgroundColor: theme.palette.primary.main,
    },
    divMarketing: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#FFF',
    },
    currencyFlagMenuItemRoot: {
      padding: '0',
      minWidth: '0',
      // marginRight: '10px',
    },
    backdrop: {
      zIndex: 1,
      color: theme.palette.primary.dark,
    },
    grow: {
      flexGrow: 1,
    },
  };
});

export default homeStyles;
